import React, { useState } from 'react';
import { MDBTable, MDBTableBody, MDBTableHead } from "mdbreact";
import { toast } from "react-toastify";
import { useEffect } from 'react';
import { th } from '../../../utils/helpers';
import { ICON_BASKET, ICON_EXCLAMATION } from '../../../utils/icons';
import ConfirmSales from './ConfirmSales';
import { Button, Select } from '../../../styles';
import { useSalesContext } from '../../../context/sales_context';
import { naira } from '../../../utils/data';
import styled from 'styled-components';
import { useUserContext } from '../../../context/user_context';
import Api from '../../../api/axios';
import { useNavigate } from 'react-router-dom';


const OrderDetails = ({ orderItem, setOrderItem, api }) => {

    const [sending, setsending] = useState(false);
    const [vat_slider, setvat_slider] = useState(false);
    const navigate = useNavigate();

    // Function to calc total

    const {
        openConfirmSales, closeConfirmSales,
        orderField, handleOrderField, setOrderField
    } = useSalesContext();

    const {
        businessData, btoken, stoken, usertoken
    } = useUserContext();

    const {
        sales_time, customer_name, customer_mail, customer_phone, details, pay_mode, vat_type
    } = orderField;

    let x = 0;
    function calcTotal() {
        const total = orderItem.map(({ amount }) => x += amount);
        return total[total.length - 1];
    }
    let total_sum = calcTotal();

    // Function to calc total


    // The VAT Rate 
    let vat_rate = (+businessData?.vat_rate / 100) || 0.00;
    let vat_value = total_sum * vat_rate;
    let total_vat = vat_slider ? th(total_sum) : th(total_sum + vat_value);
    // The VAT Rate 



    //   Add Item Details Function
    function salesAdd(e) {

        // removing item name from the array
        let newOrderItems = orderItem.map(obj => {
            delete obj.item_name;
            return obj;
        });
        // removing item name from the array

        e.preventDefault();
        if (orderItem == 0) {
            toast.warn('Select an item ...');
        } else {
            setsending(true);
            const data = {
                btoken,
                stoken,
                usertoken,
                items: newOrderItems,
                sales_time,
                customer_name,
                customer_mail,
                customer_phone,
                details,
                pay_mode,
                vat_type,
                tax_vat: vat_value,
            };
            Api.post(`/${ api }`, data)
                .then((res) => {
                    if (res.success === false) {
                        setsending(false);
                        toast.warn(res.message);
                    } else {
                        setsending(false);
                        navigate(`/user/sales/invoice/${ res.data.invid }`);
                        setTimeout(() => {
                            toast.success(res.message);
                        }, 100);
                        closeConfirmSales();
                        setOrderField('');
                    }
                })
                .catch(() => {
                    setsending(false);
                });
        }
    }

    //   Add Item Details Function


    // Del Items or Order

    const delItem = (i) => {
        orderItem.splice(i, 1);
        setOrderItem([...orderItem]);
        setTimeout(() => {
            toast.success('Item Deleted');
        }, 100);
    };
    const delAllItem = () => {
        if (orderItem.length === 0) {
            toast.warn('Order is Empty!');
        } else {
            setOrderItem([]);
            toast.success('Order Deleted');
        }
    };
    // Del Items or Order

    const payOptions = [
        { name: "POS" },
        { name: "Cash" },
        { name: "Card" },
        { name: "Transfer" },
        { name: "Others" },
    ];

    useEffect(() => {
        setOrderField({ ...orderField, vat_type: vat_slider ? "inclusive" : "exclusive" });
    }, [vat_slider]);

    return (
        <StyledOrderDetails>

            <div className="my-4">
                <h6 className="pry-bold-text br-sm p-2 sec-bold "> Order Details</h6>
            </div>

            <MDBTable small responsive bordered>
                <MDBTableHead color="sec-bold pry-bold-text" >
                    <tr>
                        <th>No.</th>
                        <th>Item Name</th>
                        <th>Quantity</th>
                        <th>Price</th>
                        <th>Amount</th>
                        <th>Delete</th>
                    </tr>
                </MDBTableHead>
                <MDBTableBody color="white" >
                    {orderItem.map((item, i) => (
                        <tr key={i}>
                            <td>{i + 1}</td>
                            <td className="pt-3-half">
                                {item.item_name}
                            </td>
                            <td>
                                {item.qty}
                            </td>
                            <td>
                                ₦{th(item.price)}
                            </td>
                            <td>
                                ₦{th(item.amount)}
                            </td>
                            <td className="text-center">
                                <a
                                    className='red-text'
                                    onClick={() => delItem(i)}
                                >
                                    {ICON_BASKET}
                                </a>
                            </td>
                        </tr>
                    ))}

                    {orderItem == 0 ?
                        <> </>
                        :
                        <>
                            <tr >
                                <td>=</td>
                                <td className="fw-bold py-3">
                                    VAT ({businessData.vat_rate || 0.00}%)
                                </td>
                                <td> </td>
                                <td> </td>
                                <td className='fw-bold py-3'>
                                    {naira}{th(vat_value)}
                                </td>
                                <td className="text-center"> </td>
                            </tr>
                            <tr >
                                <td>=</td>
                                <td className="fw-bold py-3">
                                    Total
                                </td>
                                <td> </td>
                                <td> </td>
                                <td className='fw-bold py-3'>
                                    {naira}{total_vat}
                                </td>
                                <td className="text-center"> </td>
                            </tr>
                        </>
                    }
                </MDBTableBody>
            </MDBTable>

            {orderItem == 0 ?
                <div className="text-center pry-text mt-5">
                    <span className="mt-5 h1">
                        {ICON_EXCLAMATION}
                    </span>
                    <br />
                    order is empty ...
                </div> :
                <>
                    <div className="text-end mt-4">
                        <button className="btn btn-danger btn-sm" onClick={delAllItem}>
                            <i className="light-text">
                                {ICON_BASKET}
                            </i> Clear All
                        </button>
                    </div>
                    <div className="row">
                        <div className="col-md-6 ">
                            <label className="mt-3 m-0">Mode of Payment:</label>
                            <Select
                                name="pay_mode"
                                onChange={handleOrderField}
                            >
                                <option value="">
                                    Select Mode of Payment
                                </option>
                                {payOptions.map(({ name }) =>
                                    <option
                                        value={name}
                                        key={name}
                                    >
                                        {name}
                                    </option>
                                )}
                            </Select>
                        </div>
                        <div className="col-md-6 ">
                            <label className="mt-3 m-0">VAT Type:</label>
                            <br />
                            <div className="d-flex align-items-center">
                                <label className="switch me-2">
                                    <input
                                        type="checkbox"
                                        onChange={((e) => setvat_slider(e.target.checked))}

                                    />
                                    <span className="slider round"></span>
                                </label>
                                <h5 className='mt-2 ml-2 font-weight-light'>

                                    {vat_slider ? 'INCLUSIVE' : 'EXCLUSIVE'}
                                </h5>
                            </div>
                            <div className="small pb-3">Toggle to select <span className='fw-bold'>  {vat_slider ? 'Exclusive' : 'Inclusive'}</span></div>
                        </div>
                    </div>
                    <div className="text-center">
                        <Button pry
                            className="btn w-md-100"
                            onClick={(e) => openConfirmSales()}
                        >Proceed</Button>
                    </div>
                </>}

            <ConfirmSales
                orderItem={orderItem}
                salesAdd={salesAdd}
                sending={sending}
                vat_value={vat_value}
                total_vat={total_vat}

            />

        </StyledOrderDetails>
    );
};

export default OrderDetails;

const StyledOrderDetails = styled.div`
    
    /* Slider */
/* The switch - the box around the slider */
.switch {
  position: relative;
  display: inline-block;
  width: 50px;
  height: 24px;
}

/* Hide default HTML checkbox */
.switch input {
  opacity: 0;
  width: 0;
  height: 0;
}

/* The slider */
.slider {
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: var(--sec-bold-color);
  -webkit-transition: 0.4s;
  transition: 0.4s;
}

.slider:before {
  position: absolute;
  content: "";
  height: 16px;
  width: 16px;
  left: 4px;
  bottom: 4px;
  background-color: var(--light-color);
  -webkit-transition: 0.4s;
  transition: 0.4s;
}

input:checked + .slider {
  background-color: var(--pry-color);
}

input:focus + .slider {
  box-shadow: 0 0 1px var(--pry-color);
}

input:checked + .slider:before {
  -webkit-transform: translateX(26px);
  -ms-transform: translateX(26px);
  transform: translateX(26px);
}

/* Rounded sliders */
.slider.round {
  border-radius: 34px;
}

.slider.round:before {
  border-radius: 50%;
}
/* Slider */


`;